

import { auth } from './auth';
import { apiStatus } from './apiStatus';
import { activation } from './activation';
import { clientInformation } from './clientInformation';
import { location } from './location';
import { packages } from './packages';
import { idDetails } from './idDetails';
import { otp } from './otp';
import { sales } from './sales';
import { scheduleVisit } from './scheduleVisit';
import { checkout } from  './checkout';


export default {
  auth,
  apiStatus,
  activation,
  clientInformation,
  location,
  packages,
  idDetails,
  otp,
  sales,
  scheduleVisit,
  checkout
};